import React from 'react'
import Header from '../components/header'
import Footer from '../components/footer'

export default function Contact() {
  return (
    <div>
      <Header/>

      <div
  className="center"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop:"110px"
  }}
>
  <iframe
    src="https://docs.google.com/forms/d/e/1FAIpQLSdZ1PH1VNXv9YX93YnERuVf2vqLy62XSVICs4EaychWrHXwzw/viewform?embedded=true"
    width="640"
    style={{ minWidth: "300px" }}
    height="900"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
    title="ToolISO Form"
  >
    Loading…
  </iframe>
</div>


      <Footer/>
    </div>
  )
}
